import * as _ from "lodash";
import { CommsRepo } from "@services/communications.repo";
import * as moment from "moment";
import { CommItem } from "@app/communications/Communication";

class commListController implements angular.IOnInit {
  public comms: CommItem[];
  public searchText: string;

  /** @ngInject */
  constructor(
    private fileRepo: CommsRepo,
    private $state: angular.ui.IStateService,
    private notifyjs: any,
    private $window: angular.IWindowService
  ) {}

  $onInit() {
    this.getComms();
  }

  getComms() {
    this.fileRepo.getComms().then((res) => {
      this.comms = res;
    });
  }

  downloadFileUrl(file) {
    this.$window.open(file.url, "_blank");
  }

  createNewComm() {
    this.$state.go("root.communication.create");
  }

  setActive(comm) {
    this.fileRepo
      .updateCommActive(comm)
      .then(() => {
        this.getComms();
      })
      .catch((err) =>
        this.notifyjs(`Failed to update communication: ${err.error}`)
      );
  }

  isDisabled(comm) {
    if (comm.file.key === "") {
      return true;
    }
    return false;
  }
}

export const commList: angular.IComponentOptions = {
  template: require("./communicationList.html"),
  controller: commListController,
};



// WEBPACK FOOTER //
// ./src/app/communications/communicationList.ts